import { createAction } from '@reduxjs/toolkit';

import { RegistrationStatus } from '../types';

export const updateRegistrationStatus = createAction<RegistrationStatus>('auth/updateRegistrationStatus');
